import type { PropCategory } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { DesignProp } from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const getPaddingOptions = ({
  defaultValue = {
    paddingTop: "10",
    paddingBottom: "10",
    paddingLeft: "10",
    paddingRight: "10",
  },
  category = [DesignProp],
}: {
  defaultValue?: {
    paddingTop: string;
    paddingBottom: string;
    paddingLeft: string;
    paddingRight: string;
  };
  category?: PropCategory[];
}): StyleValue => ({
  type: "box-model",
  value: defaultValue,
  meta: {
    name: "Padding",
    nameI18n: "builder_ui.prop_type.styles.padding",
    category,
    boxModelType: "padding",
  },
});

export const getMarginOptions = ({
  defaultValue = {
    marginTop: "10",
    marginBottom: "10",
    marginLeft: "10",
    marginRight: "10",
  },
  category = [DesignProp],
}: {
  defaultValue?: {
    marginTop: string;
    marginBottom: string;
    marginLeft: string;
    marginRight: string;
  };
  category?: PropCategory[];
}): StyleValue => ({
  type: "box-model",
  value: defaultValue,
  meta: {
    name: "Margin",
    nameI18n: "builder_ui.prop_type.styles.margin",
    category,
    boxModelType: "margin",
  },
});
